import CONSTANT, { CACHE } from '../utils/constants';
import { EVENT, log } from './logger';
import { getKey, isArray } from '../utils/common';

const msgHandler = (cache, resolve, event) => {
  switch (getKey(event, 'data.type')) {
    case 'fetchedData':
      cache.setData(CONSTANT.SAVED_PAYMODES, getKey(event, 'data.resp'));
      window.removeEventListener('message', msgHandler);
      resolve(getKey(event, 'data.resp'));
      break;
    default:
      break;
  }
};

export const processLocalStorage = cache => {
  try {
    const savedPaymodesArray = cache.getData(CONSTANT.SAVED_PAYMODES);
    if (
      savedPaymodesArray &&
      savedPaymodesArray.length > 0 &&
      window &&
      window.localStorage &&
      cache.getData(CONSTANT.IS_LOCAL_STORAGE_ALLOWED) &&
      cache.getData(CONSTANT.IS_LOGGED_IN)
    ) {
      const mobileNo =
        cache.getData(CONSTANT.MOBILE_NO) && cache.getData(CONSTANT.MOBILE_NO).slice(0, 4);

      const result = {};
      savedPaymodesArray.forEach(item => {
        if (item.userId === mobileNo) {
          if (item.uniqueCardData) {
            result[`${item.paymodeUsed}_${item.isWalletCheck}`] =
              savedPaymodesArray.filter(e => {
                return (
                  e.paymodeUsed === item.paymodeUsed &&
                  e.uniqueCardData === item.uniqueCardData &&
                  e.isWalletCheck === item.isWalletCheck &&
                  e.userId === mobileNo
                );
              }).length > 1
                ? (result[`${item.paymodeUsed}_${item.isWalletCheck}`] = 1 || 0)
                : 0;
          } else {
            result[`${item.paymodeUsed}_${item.isWalletCheck}`] =
              savedPaymodesArray.filter(e => {
                return (
                  e.paymodeUsed === item.paymodeUsed &&
                  e.isWalletCheck === item.isWalletCheck &&
                  e.userId === mobileNo
                );
              }).length > 1
                ? (result[`${item.paymodeUsed}_${item.isWalletCheck}`] = 1 || 0)
                : 0;
          }
        }
      });

      if (Object.keys(result).length) {
        const duplicateArray = savedPaymodesArray.filter(
          mode => result[`${mode.paymodeUsed}_${mode.isWalletCheck}`]
        );
        if (duplicateArray && duplicateArray.length > 0) {
          cache.setData(CONSTANT.CURRENT_PAYMODE, duplicateArray[0]);
          return;
        }
        cache.setData(CONSTANT.CURRENT_PAYMODE, savedPaymodesArray[0]);
      }
    }
  } catch (e) {
    log({
      eventType: EVENT.EXCEPTION,
      message: e.message,
      name: e.name
    });
  }
};

export const getDataFromLocalStorage = cache => {
  return new Promise(resolve => {
    const dummyFrame = document.getElementById('dummy-iframe');
    dummyFrame.contentWindow.postMessage({ type: 'FETCHDATA', key: 'savedPaymodes' }, '*');
    window.addEventListener('message', msgHandler.bind(null, cache, resolve));
    setTimeout(() => {
      resolve();
    }, 3000);
  });
};

export const savingUsedPaymodeInLocalStorage = cache => {
  try {
    const dummyFrame = document.getElementById('dummy-iframe');
    window.addEventListener('message', msgHandler.bind(null, cache));
    const selectedPaymode = cache.getData(CONSTANT.CURRENT_PAYMODE);
    const usedPaymode = getKey(selectedPaymode, 'paymentMode');
    // check whether localStorage api exists on window object
    if (
      selectedPaymode !== CONSTANT.WALLET &&
      window &&
      window.localStorage &&
      cache.getData(CONSTANT.IS_LOCAL_STORAGE_ALLOWED) &&
      cache.getData(CONSTANT.IS_LOGGED_IN)
    ) {
      const savedPaymodesArray = cache.getData(CONSTANT.SAVED_PAYMODES) || [];
      const mobileNo =
        cache.getData(CONSTANT.MOBILE_NO) && cache.getData(CONSTANT.MOBILE_NO).slice(0, 4);
      const paymodeObj = {
        isWalletCheck: getKey(cache.getData(CACHE.PAYMENT_OPTIONS), 'wallet.isUsed', undefined),
        paymodeUsed: getKey(selectedPaymode, 'savedName') || getKey(selectedPaymode, 'displayName'),
        userId: mobileNo
      };

      if (usedPaymode && (usedPaymode === CONSTANT.DC || usedPaymode === CONSTANT.CC)) {
        paymodeObj.paymodeUsed = 'card';
        paymodeObj.subType = cache.getData(CONSTANT.CARD_TYPE) || '';
      }

      if (getKey(selectedPaymode, 'paymentMode') === 'GIFT_VOUCHER') {
        paymodeObj.isMGV = true;
      }
      if (
        typeof getKey(selectedPaymode, 'id', undefined) === 'string' &&
        getKey(selectedPaymode, 'id').indexOf('emi') > -1
      ) {
        paymodeObj.paymodeUsed = 'EMI';
      }
      /* eslint valid-typeof: ["error", { "requireStringLiterals": false }] */
      // this is required to differentiate b/w different saved(DC/CC) cards of same bank
      if (
        getKey(selectedPaymode, 'type') === 'sc' &&
        typeof getKey(selectedPaymode, 'id', undefined) === 'number'
      ) {
        paymodeObj.uniqueCardData = selectedPaymode.lastFour;
      }
      const currentUserPaymodes =
        savedPaymodesArray.length > 0 &&
        savedPaymodesArray.filter(paymode => {
          return paymode.userId === mobileNo;
        });
      if (isArray(currentUserPaymodes) && currentUserPaymodes.length === 3) {
        savedPaymodesArray.splice(savedPaymodesArray.lastIndexOf(currentUserPaymodes[2]), 1);
      }

      log({
        eventType: EVENT.SAVING_CURRENT_PAYMODE,
        paymodeUsed: paymodeObj
      });
      savedPaymodesArray.unshift(paymodeObj);
      log({
        eventType: EVENT.PERSISTED_ARRAY,
        persistedLocalStorageArray: savedPaymodesArray
      });

      dummyFrame.contentWindow.postMessage(
        { type: 'SETDATA', key: 'savedPaymodes', data: savedPaymodesArray },
        '*'
      );
    }
  } catch (e) {
    log({
      eventType: EVENT.EXCEPTION,
      message: e.message,
      name: e.name
    });
  }
};



// WEBPACK FOOTER //
// ./common/localStorage.js